"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(portalSettingKey) {
  return function (_ref) {
    var portalSettings = _ref.portalSettings;
    return portalSettingKey in portalSettings;
  };
};

exports.default = _default;
module.exports = exports.default;